var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "232 -776 496 544",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-352.92 346.46-486.46l23.31-21.77L464-414v-362h32v362l94.23-94.23 23.31 21.77zM288.33-232Q264-232 248-248.15t-16-40.47v-48.92h32v48.92q0 9.24 7.69 16.93t16.93 7.69h382.76q9.24 0 16.93-7.69t7.69-16.93v-48.92h32v48.92q0 24.32-16.16 40.47T671.34-232z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d443847d407823a8b0ba71668abadf7a.svg";
export { ForwardRef as ReactComponent };